import SidebarTooltip from './SidebarTooltip';

/**
 * ActivityIcon — jedna ikona v liště.
 *
 * - modul: aktivní = otevřená stránka (sytější pozadí + 2 px proužek vlevo),
 *   název ukáže tooltip
 * - sekce (`isSection`): aktivní = otevřená stránka patří do sekce; otevřený
 *   panel sekci jen jemně podbarví. Tooltip nemá — název ukazuje panel.
 *
 * @param {Object} props
 * @param {React.ComponentType} props.Icon
 * @param {string} props.label - Tooltip / aria-label
 * @param {boolean} [props.active]
 * @param {boolean} [props.isSection]
 * @param {boolean} [props.sectionOpen] - Panel sekce je otevřený
 * @param {string} [props.accentColor]
 * @param {number} [props.badge] - Počet (modul)
 * @param {boolean} [props.dot] - Puntík „něco čeká" (sekce)
 * @param {boolean} [props.isDark]
 */
export default function ActivityIcon({
    Icon,
    label,
    active = false,
    isSection = false,
    sectionOpen = false,
    accentColor = '#FF8A00',
    badge = 0,
    dot = false,
    isDark = true,
    onClick,
    onMouseEnter,
}) {
    const zvyraznena = active || (isSection && sectionOpen);
    const bgColor = active ? `${accentColor}24` : zvyraznena ? `${accentColor}18` : 'transparent';
    const iconColor = zvyraznena ? accentColor : (isDark ? 'rgba(255,255,255,0.55)' : 'rgba(0,0,0,0.45)');

    const btn = (
        <button
            type="button"
            onClick={onClick}
            onMouseEnter={onMouseEnter}
            aria-label={label}
            style={{
                position: 'relative',
                width: 40,
                height: 40,
                margin: '2px auto',
                borderRadius: 6,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: bgColor,
                border: 'none',
                cursor: 'pointer',
                transition: 'background 0.15s ease, color 0.15s ease',
            }}
            onMouseOver={(e) => {
                if (!zvyraznena) e.currentTarget.style.background = isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)';
            }}
            onMouseOut={(e) => {
                if (!zvyraznena) e.currentTarget.style.background = 'transparent';
            }}
        >
            {active && (
                <span
                    aria-hidden="true"
                    style={{
                        position: 'absolute', left: -8, top: 6, bottom: 6,
                        width: 2, borderRadius: 2, background: accentColor,
                    }}
                />
            )}

            <Icon size={22} strokeWidth={active ? 2.4 : 1.8} color={iconColor} />

            {badge > 0 && (
                <span
                    style={{
                        position: 'absolute', top: 2, right: 2,
                        minWidth: 14, height: 14, padding: '0 3px',
                        background: '#FF8A00', color: '#fff',
                        fontSize: 9, fontWeight: 700, borderRadius: 5,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        lineHeight: 1, border: '1.5px solid var(--surface-sidebar)',
                    }}
                >
                    {badge > 9 ? '9+' : badge}
                </span>
            )}
            {!badge && dot && (
                <span
                    aria-hidden="true"
                    style={{
                        position: 'absolute', top: 6, right: 6,
                        width: 7, height: 7, borderRadius: '50%',
                        background: '#FF8A00', boxShadow: '0 0 0 1.5px var(--surface-sidebar)',
                    }}
                />
            )}
        </button>
    );

    if (isSection) return btn;

    return (
        <SidebarTooltip label={label}>
            {btn}
        </SidebarTooltip>
    );
}
